import React from 'react'
import { OptionalTag } from '../OptionalTag'
import FlexView from 'react-flexview/lib'

export const ProfilePicturePopover = () => {

    return (
        <FlexView vAlignContent={'center'}>
            <div className="text-small margin-right-6">Your logo will appear on your certificate of insurance</div>
          <OptionalTag />
        </FlexView>)
}